<hsg-modal>
  <span class="title">{{data.title}}</span>
  <div [gaManager]="{type:'impression',category:this.gaCategory,action:data.gaAction,label:data.gaLabel}" class="body">
    <p>
        {{data.content}}
    </p>
  </div>
  <div class="actions">
    <button hsg-button kind="primary" (click)="finish()">אישור
    </button>
  </div>
  <div class="right" *ngIf="data?.showContactCall != false && isShowContactLink">
    <span>
      צריך עזרה?
      <a href="#" (click)="close(true,'סיום תהליך')">צור קשר</a>
    </span>
  </div>
</hsg-modal>